module.exports = __webpack_public_path__ + "img/avatar1.10bc5f16.png";